import Vue from 'vue';

export class ProdForm {
  public static frontend(el: HTMLElement, opt: any) {
    return new ProdForm(el, opt);
  }

  public vue: Vue;

  constructor(
    public el: HTMLElement,
    opt: {prod: {id: number; title: string; code: string; price: number}},
  ) {
    const formater = new Intl.NumberFormat(
      navigator?.languages?.[0] || 'en-AU',
      {
        style: 'currency',
        currency: 'AUD',
      },
    );

    this.vue = new Vue({
      data: {
        prod: opt.prod,
        bundle: [],
      },
      computed: {
        price() {
          return this.prod.price + this.bundle.reduce((t, i) => t + i.price, 0);
        },
        prettyPrice() {
          return formater.format(this.price);
        },
      },
      watch: {
        prettyPrice(v) {
          const form = el.firstElementChild;
          el.querySelectorAll('[data-field=price]').forEach(
            (n) => (n.innerHTML = v),
          );
          Array.from(form.children)
            .filter((c) => c.tagName === 'INPUT' && /^ProdForm/.test(c.name))
            .forEach((c) => form.removeChild(c));
          if (this.bundle.length > 0) {
            const bundleItem = document.createElement(
              'input',
            ) as HTMLInputElement;
            this.bundle
              .map((item) => {
                const bundleItem = document.createElement('input');
                bundleItem.name = 'ProdForm[all][Bundle][]';
                bundleItem.value = String(item.id);
                bundleItem.type = 'hidden';
                return bundleItem;
              })
              .forEach((bundleItem) => form.appendChild(bundleItem));
          }
        },
      },
    });
    el.childNodes.forEach((n) => (n['vue'] = this.vue));
  }
}
